import Container from "./container";
import logo from "../../assets/images/commalax-landing/logo.png";
const Header = () => {
  return (
    <Container>
      <div className="flex items-center justify-center">
        <a href="#">
          <img src={logo} className="max-w-[200px]" alt="commalax logo" />
        </a>
      </div>
    </Container>
  );
};
export default Header;
